<app-organizer-shared-layout-dashboard
  class="organizer-messaging-page-inbox"
  [fullWidth]="true"
  [hasFooter]="true"
  footerClass="hidden lg:block"
>
  <div class="col-span-12 md:col-span-5 md:col-start-2">
    <app-messaging-inbox [recipient]="recipient"></app-messaging-inbox>
  </div>
</app-organizer-shared-layout-dashboard>
